import {
  STUDENT_COURSES_REQUEST,
  STUDENT_COURSES_RESPONSE,
  STUDENT_PROFILE_REQUEST,
  STUDENT_PROFILE_RESPONSE,
  STUDENT_PROFILE_CREATE,
  STUDENT_PROFILE_EDIT,
} from '../reducers'
import { all, put, takeEvery } from 'redux-saga/effects'

import { userLogin } from 'admin-on-rest'

import * as firebase from 'firebase'
import { getStudentName, capitalize } from '../helpers'

function* fetchCredits(action) {
  try {
    const data = yield firebaseGetCredits()
    if (data) {
      yield put({ type: STUDENT_COURSES_RESPONSE, data })
    }
  } catch (e) {
    // yield put({ type: FETCHING_DATA_FAILURE })
    //console.log('Error on fetchProfile ', e)
  }
}

const firebaseGetCredits = () => {
  // Get the user logged in
  const user = firebase.auth().currentUser

  if (user) {
    const uid = user.uid
    return firebase
      .database()
      .ref(`students/${uid}/courses`)
      .once('value')
      .then(snapshot => {
        let studentCourses = { ...snapshot.val() }
        let completedStudentCourses = {}
        Object.keys(studentCourses).map(key => {
          if (studentCourses[key].status === 'completed') {
            completedStudentCourses[key] = studentCourses[key]
          }
        })
        return Promise.all(
          Object.keys(completedStudentCourses).map(courseId =>
            firebase
              .database()
              .ref(`courses/${courseId}`)
              .once('value')
              .then(response => {
                completedStudentCourses[courseId] = {
                  course: { ...response.val() },
                  ...completedStudentCourses[courseId],
                  id: response.key,
                }
              }),
          ),
        ).then(responseAll => {
          return completedStudentCourses
        })
      })
  }
}

function* fetchProfile(action) {
  try {
    const data = yield firebaseGetProfile()
    if (data) {
      yield put({ type: STUDENT_PROFILE_RESPONSE, data })
    }
  } catch (e) {
    // yield put({ type: FETCHING_DATA_FAILURE })
    //console.log('Error on fetchProfile ', e)
  }
}

const firebaseGetProfile = () => {
  // Get the user logged in
  const user = firebase.auth().currentUser

  if (user) {
    const uid = user.uid
    return firebase
      .database()
      .ref(`students/${uid}`)
      .once('value')
      .then(snapshot => {
        const profileValues = {
          ...snapshot.val(),
          email: user.email,
        }

        return profileValues
      })
  }
}

function* createProfile(action) {
  try {
    const userData = action.data
    const userCreationData = yield firebaseCreateProfile(userData)
    if (userCreationData) {
      yield put(
        userLogin({
          username: userData.email,
          password: userData.password,
        }),
      )
    }
  } catch (e) {
    //console.log('Error on createProfile ', e)
    // yield put({ type: FETCHING_DATA_FAILURE })
  }
}

const firebaseCreateProfile = data => {
  return firebase
    .auth()
    .createUserWithEmailAndPassword(data.email, data.password)
    .then(newUser => {
      const user = newUser.user
      const uid = user.uid
      data.firstName = capitalize(data.firstName)
      data.lastName = capitalize(data.lastName)
      const displayName = getStudentName(data)
      // const phoneNumber = `${data.phoneNumber}`

      const p1 = user.updateProfile({
        displayName: displayName,
      })

      let studentData = { ...data, password: null }
      var updates = {
        [`students/${uid}`]: studentData,
        [`permissions/${uid}`]: {
          student: true,
        },
      }
      const p2 = firebase
        .database()
        .ref()
        .update(updates)

      const p3 = user.sendEmailVerification()

      return Promise.all([p1, p2, p3])
    })
}

function* editProfile(action) {
  try {
    const userData = action.data
    const userEditData = yield firebaseEditProfile(userData)

    if (userEditData) {
      yield put({ type: STUDENT_PROFILE_REQUEST })
    }
  } catch (e) {
    //console.log('Error on editProfile')
  }
}

const firebaseEditProfile = data => {
  const user = firebase.auth().currentUser

  //TODO - edit phone number and password

  data.firstName = capitalize(data.firstName)
  data.lastName = capitalize(data.lastName)

  const uid = user.uid
  const displayName = getStudentName(data)

  const p1 = user.updateProfile({
    displayName: displayName,
  })

  let studentData = { ...data }
  // Don't allow updates to phone or email
  delete studentData.phoneNumber
  delete studentData.email

  const p2 = firebase
    .database()
    .ref(`students/${uid}`)
    .update(studentData)

  return Promise.all([p1, p2])
}

function* studentProfileSaga() {
  try {
    yield all([
      takeEvery(STUDENT_COURSES_REQUEST, fetchCredits),
      takeEvery(STUDENT_PROFILE_REQUEST, fetchProfile),
      takeEvery(STUDENT_PROFILE_CREATE, createProfile),
      takeEvery(STUDENT_PROFILE_EDIT, editProfile),
    ])
  } catch (e) {
    //console.log('error in studentProfileSaga', e)
  }
}

export default studentProfileSaga



// WEBPACK FOOTER //
// ./src/sagas/studentsSaga.js